// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable quote-props */
export const VERSION = {
    "dirty": false,
    "raw": "d01114d",
    "hash": "d01114d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "d01114d",
    "semverString": null,
    "version": "2026.11.1"
};
